module.exports = {"230523100":"宝清镇","230523101":"七星泡镇","230523102":"青原镇","230523103":"夹信子镇","230523104":"龙头镇","230523105":"小城子镇","230523202":"朝阳乡","230523203":"万金山乡","230523204":"尖山子乡","230523209":"七星河乡","230523400":"双鸭山林业局上游经营所","230523401":"双鸭山林业局南瓮泉经营所","230523402":"双鸭山林业局七一林场","230523403":"双鸭山林业局七星河林场","230523404":"双鸭山林业局红旗林场","230523405":"双鸭山林业局三岔河林场","230523406":"双鸭山林业局青龙林场","230523407":"双鸭山林业局宝石经营所","230523408":"双鸭山林业局七星河金矿","230523409":"桦南林业局岚峰林场","230523500":"五九七农场","230523501":"八五二农场","230523502":"八五三农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230523.json
// module id = 729
// module chunks = 0